import { render } from "./SubiektDaysModal.vue?vue&type=template&id=2191b3fd&scoped=true"
import script from "./SubiektDaysModal.vue?vue&type=script&lang=js"
export * from "./SubiektDaysModal.vue?vue&type=script&lang=js"

import "./SubiektDaysModal.vue?vue&type=style&index=0&id=2191b3fd&scoped=true&lang=css"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2191b3fd"]])

export default __exports__